<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow bg-secondary">
            <div class="col p-3">
              <button @click="$router.go(-1)" class="btn btn-primary btn-sm">
                <strong>&#60; ย้อนกลับ</strong>
              </button>
            </div>
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    กรุณากรอกข้อมูลเพื่อทำการคำนวณภาษี
                  </h3>
                </div>
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-xs-12">
                  <div class="card est-box">
                    <div class="row p-4">
                      <div class="col-xl-6">
                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-xs-12 mb-2">
                            <select
                              class="form-control"
                              v-model="selectedType"
                              @change="onTypeChange($event)"
                              ><option
                                v-for="type in masterCarType"
                                :key="type.id"
                                :selected="selectedType === type.id"
                                :value="type.id"
                                >{{ type.name }}</option
                              ></select
                            >
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-xs-12">
                            <select
                              :disabled="selectedType == 0 ? true : false"
                              class="form-control"
                              v-model="selectedSubType"
                              @change="onSubTypeSelected($event)"
                              ><option
                                v-for="subType in getCarSubType()"
                                :key="subType.id"
                                :selected="selectedSubType === subType.id"
                                :value="subType.id"
                                >{{ subType.name }}</option
                              >
                            </select>
                          </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                          <div class="col-lg-7 col-md-6 col-xs-6">
                            <div class="row row-options2">
                              <div class="col-12">
                                <input
                                  type="text"
                                  pattern="\d*"
                                  maxlength="10"
                                  placeholder="วันที่จดทะเบียน"
                                  class="form-control input-detail input-tax-data"
                                  v-mask="'##/##/####'"
                                  v-model="registered_date"
                                />
                              </div>
                            </div>
                            <div class="row row-options2">
                              <div class="col-12">
                                <input
                                  :disabled="selectedType == 3"
                                  type="text"
                                  pattern="\d*"
                                  maxlength="4"
                                  placeholder="เครื่องยนต์ (ซีซี)"
                                  v-mask="'####'"
                                  class="form-control input-detail input-tax-data"
                                  v-model="cc"
                                />
                              </div>
                            </div>
                            <div class="row row-options2">
                              <div class="col-12">
                                <input
                                  :disabled="
                                    selectedType == 1 || selectedType == 4
                                  "
                                  type="text"
                                  pattern="\d*"
                                  maxlength="5"
                                  placeholder="น้ำหนักรถเปล่า (กก.)"
                                  class="form-control input-detail input-tax-data"
                                  v-mask="'#####'"
                                  v-model="weight"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-6">
                            <div class="row row-options2">
                              <div class="col-12">
                                <button
                                  type="button"
                                  class="btn btn-block waves-effect waves-light btn-secondary"
                                  style="height: 56px; font-size: 16px;"
                                  @click="showTaxModal = true"
                                >
                                  วันครบภาษี
                                  <span class="text-red">{{
                                    cover_end_date
                                  }}</span>
                                </button>
                              </div>
                            </div>
                            <div class="row row-options2">
                              <div class="col-12">
                                <button
                                  type="button"
                                  class="btn btn-secondary btn-block waves-effect waves-light"
                                  style="height: 56px; font-size: 16px;"
                                  @click="showTaxModal = true"
                                >
                                  วันที่ยื่นภาษี
                                  <span class="text-red">{{ formatRenewDate() }}</span>
                                </button>
                              </div>
                            </div>
                            <div class="row row-options2">
                              <div class="col-12">
                                <div role="group" class="btn-group">
                                  <button
                                    type="button"
                                    class="btn"
                                    :class="
                                      btnEvState
                                        ? 'btn-warning'
                                        : 'btn-secondary'
                                    "
                                    @click="
                                      (btnEvState = !btnEvState),
                                        btnEvState && btnHybridState
                                          ? (btnHybridState = false)
                                          : ''
                                    "
                                  >
                                    <small>EV / แก๊ส 100%</small>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-secondary"
                                    :class="
                                      btnHybridState
                                        ? 'btn-warning'
                                        : 'btn-secondary'
                                    "
                                    @click="
                                      (btnHybridState = !btnHybridState),
                                        btnHybridState && btnEvState
                                          ? (btnEvState = false)
                                          : ''
                                    "
                                  >
                                    <small>Hybrid / CNG</small>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-secondary"
                                    :class="
                                      btnJuristicState
                                        ? 'btn-warning'
                                        : 'btn-secondary'
                                    "
                                    @click="
                                      btnJuristicState = !btnJuristicState
                                    "
                                  >
                                    <small>นิติบุคคล<br />x2</small>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="selectedType != 0"
                          class="row row-options active mt-2"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="form-control form-label text-white">
                              ตรวจสภาพรถ
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                :readonly="!isCheckPaymentEnable"
                                placeholder="0.00"
                                maxlength="7"
                                v-model="checkPrice"
                                class="form-control text-right input-price"
                              />
                              <div
                                class="input-group-append click"
                                @click="
                                  (isCheckPaymentEnable = !isCheckPaymentEnable),
                                    recalculate()
                                "
                              >
                                <span class="input-group-text"
                                  ><i
                                    class="fa fa-lg fa-check"
                                    :class="
                                      isCheckPaymentEnable
                                        ? 'text-check'
                                        : 'text-uncheck'
                                    "
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="input-group">
                              <div class="form-control form-label text-white">
                                พ.ร.บ.
                              </div>
                              <div class="input-group-prepend">
                                <small class="label float-right text-white"
                                  >{{ wsuDate }} วัน</small
                                >
                                <button
                                  type="button"
                                  @click="showWSUModal = true"
                                  class="btn btn-light"
                                >
                                  <i class="fa fa-calendar"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                :readonly="!isWSUPaymentEnable"
                                placeholder="0.00"
                                maxlength="7"
                                v-model="wsuPrice"
                                class="form-control text-right input-price click"
                              />
                              <div
                                class="input-group-append click"
                                @click="
                                  (isWSUPaymentEnable = !isWSUPaymentEnable),
                                    recalculate()
                                "
                              >
                                <span class="input-group-text"
                                  ><i
                                    class="fa fa-lg fa-check"
                                    :class="
                                      isWSUPaymentEnable
                                        ? 'text-check'
                                        : 'text-uncheck'
                                    "
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="input-group">
                              <div class="form-control form-label text-white">
                                ภาษีประจำปี
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                :readonly="!isTaxPaymentEnable"
                                placeholder="0.00"
                                maxlength="7"
                                v-model="taxPrice"
                                class="form-control text-right input-price click"
                              />
                              <div
                                class="input-group-append click"
                                @click="
                                  (isTaxPaymentEnable = !isTaxPaymentEnable),
                                    recalculate()
                                "
                              >
                                <span class="input-group-text"
                                  ><i
                                    class="fa fa-lg fa-check"
                                    :class="
                                      isTaxPaymentEnable
                                        ? 'text-check'
                                        : 'text-uncheck'
                                    "
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="selectedType != 0" class="row row-options">
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="form-control form-label text-white">
                              ค่าปรับภาษี
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                :readonly="!isTaxFinePaymentEnable"
                                placeholder="0.00"
                                maxlength="7"
                                v-model="taxFinePrice"
                                class="form-control text-right input-price click"
                              />
                              <div
                                class="input-group-append click"
                                @click="
                                  (isTaxFinePaymentEnable = !isTaxFinePaymentEnable),
                                    recalculate()
                                "
                              >
                                <span class="input-group-text"
                                  ><i
                                    class="fa fa-lg fa-check"
                                    :class="
                                      isTaxFinePaymentEnable
                                        ? 'text-check'
                                        : 'text-uncheck'
                                    "
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="selectedType != 0" class="row row-options">
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="form-control form-label text-white">
                              ค่าบริการ
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                :readonly="!isServicePaymentEnable"
                                placeholder="0.00"
                                maxlength="7"
                                v-model="servicePrice"
                                class="form-control text-right input-price click"
                              />
                              <div
                                class="input-group-append click"
                                @click="
                                  (isServicePaymentEnable = !isServicePaymentEnable),
                                    recalculate()
                                "
                              >
                                <span class="input-group-text"
                                  ><i
                                    class="fa fa-lg fa-check"
                                    :class="
                                      isServicePaymentEnable
                                        ? 'text-check'
                                        : 'text-uncheck'
                                    "
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="form-control form-label text-white">
                              บริการต่อภาษี
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                onkeypress="return isFloat(event)"
                                placeholder="0.00"
                                class="form-control text-right input-price"
                              />
                              <div class="input-group-append click">
                                <span class="input-group-text"
                                  ><i class="fa fa-lg fa-check text-check"></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="form-control form-label text-white">
                              ค่าบริการออก พ.ร.บ.
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                onkeypress="return isFloat(event)"
                                placeholder="0.00"
                                class="form-control text-right input-price"
                              />
                              <div class="input-group-append click">
                                <span class="input-group-text"
                                  ><i class="fa fa-lg fa-check text-check"></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="input-group">
                              <div class="form-control form-label text-white">
                                ประกัน
                              </div>
                              <div class="input-group-append" style="">
                                <div class="btn-group">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#installmentTableModal"
                                    disabled="disabled"
                                    class="btn btn-light mr-2"
                                  >
                                    ชำระเต็ม
                                    <i class="fas fas fa-angle-down"></i>
                                  </button>
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#insureModal"
                                    class="btn dropdown-toggle btn-danger"
                                  >
                                    ป.2+
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                onkeypress="return isFloat(event)"
                                placeholder="0.00"
                                class="form-control text-right input-price require"
                              />
                              <div class="input-group-append click">
                                <span class="input-group-text"
                                  ><i class="fa fa-lg fa-check text-check"></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="input-group">
                              <div class="form-control form-label text-white">
                                ขนส่ง
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                onkeypress="return isFloat(event)"
                                placeholder="0.00"
                                class="form-control text-right input-price require"
                              />
                              <div class="input-group-append click">
                                <span class="input-group-text"
                                  ><i class="fa fa-lg fa-check text-check"></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="input-group">
                              <div class="form-control form-label text-white">
                                อื่น ๆ
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                :readonly="!isOtherPaymentEnable"
                                placeholder="0.00"
                                maxlength="7"
                                v-model="otherPrice"
                                class="form-control text-right input-price"
                              />
                              <div
                                class="input-group-append click"
                                @click="
                                  (isOtherPaymentEnable = !isOtherPaymentEnable),
                                    recalculate()
                                "
                              >
                                <span class="input-group-text"
                                  ><i
                                    class="fa fa-lg fa-check"
                                    :class="
                                      isOtherPaymentEnable
                                        ? 'text-check'
                                        : 'text-uncheck'
                                    "
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="form-control form-label text-white">
                              EMS
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                onkeypress="return isFloat(event)"
                                placeholder="0.00"
                                class="form-control text-right input-price"
                              />
                              <div class="input-group-append click">
                                <span class="input-group-text"
                                  ><i class="fa fa-lg fa-check text-check"></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- <div
                          v-if="selectedType != 0"
                          class="row row-options active"
                        >
                          <div class="col-lg-7 col-md-6 col-xs-7">
                            <div class="input-group">
                              <div class="form-control form-label text-white">
                                ค่าธรรมเนียมแบ่งชำระ
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-6 col-xs-5">
                            <div class="input-group">
                              <input
                                type="text"
                                onkeypress="return isFloat(event)"
                                placeholder="0.00"
                                class="form-control text-right input-price require"
                              />
                              <div class="input-group-append click">
                                <span class="input-group-text"
                                  ><i class="fa fa-lg fa-check text-check"></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                      </div>
                      <div class="col-xl-6">
                        <!---->
                        <div class="row">
                          <div class="col-md-12 no-padding total-price">
                            <animated-number
                              :value="calculateFinalPrice()"
                              :formatValue="formatToPrice"
                              :duration="duration"
                              class="label-price"
                            />
                          </div>
                        </div>
                        <div id="svFormat" style="display: none;">
                          <table class="other-remark">
                            <tbody></tbody>
                          </table>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-md-12 no-padding">
                            <div
                              v-if="selectedType !== 4"
                              class="label-number text-center"
                              :class="isRedLabel ? 'red-label' : ''"
                            >
                              <span
                                title="เปิด/ปิด ป้ายแดง"
                                :class="
                                  isRedLabel ? 'bt-white-label' : 'bt-red-label'
                                "
                                @click="isRedLabel = !isRedLabel"
                              >
                              </span>
                              <div
                                style="margin-bottom: 15px; font-size: 30px;"
                              >
                                <input
                                  :disabled="
                                    license_plate_suffix == '' ||
                                      isRedLabel === true
                                  "
                                  type="text"
                                  pattern="\d*"
                                  maxlength="3"
                                  placeholder=""
                                  class="lb-char text-right"
                                  v-model="license_plate_prefix"
                                />
                                <span>
                                  -
                                </span>
                                <vue-suggestion
                                  :disabled="isRedLabel === true"
                                  ref="license_plate_suffix"
                                  :items="items"
                                  :minLen="1"
                                  :maxLen="4"
                                  :setLabel="setLabel"
                                  :itemTemplate="itemTemplate"
                                  class="lb-number"
                                  @changed="inputChange"
                                  @selected="itemSelected"
                                >
                                </vue-suggestion>
                                <!-- <input
                                  :disabled="isRedLabel === true"
                                  type="text"
                                  pattern="\d*"
                                  maxlength="4"
                                  placeholder=""
                                  v-mask="'####'"
                                  class="lb-number"
                                  v-model="license_plate_suffix"
                                /> -->
                              </div>
                              <!---->
                              <!-- <Select2
                                :disabled="isRedLabel === true"
                                v-model="province"
                                placeholder="-- กรุณาเลือกจังหวัด --"
                                :options="masterProvince"
                                @change="myChangeEvent($event)"
                                @select="mySelectEvent($event)"
                              /> -->
                              <v-select
                                :options="masterProvince"
                                v-model="province"
                                label="name"
                              ></v-select>
                            </div>
                            <div
                              class="label-number-motorcy text-center"
                              :class="[(isRedLabel ? 'red-label' : ''),(selectedType !== 4 ? 'd-none' : '')]"
                            >
                              <div
                                title="เปิด/ปิด ป้ายแดง"
                                :class="
                                  isRedLabel ? 'bt-white-label' : 'bt-red-label'
                                "
                                @click="isRedLabel = !isRedLabel"
                              ></div>
                              <div style="margin-bottom: 15px;">
                                <input
                                  :disabled="
                                    license_plate_suffix == '' ||
                                      isRedLabel === true
                                  "
                                  type="text"
                                  pattern="\d*"
                                  maxlength="3"
                                  placeholder=""
                                  class="lb-char-motorcy text-center"
                                  v-model="license_plate_prefix"
                                />
                                <br />
                                <v-select
                                  :options="masterProvince"
                                  v-model="province"
                                  label="name"
                                ></v-select>
                                <vue-suggestion
                                  :disabled="isRedLabel === true"
                                  ref="license_plate_suffix_m"
                                  :items="items"
                                  :minLen="1"
                                  :maxLen="4"
                                  :setLabel="setLabel"
                                  :itemTemplate="itemTemplate"
                                  class="lb-number-motorcy"
                                  @changed="inputChange"
                                  @selected="itemSelected"
                                >
                                </vue-suggestion>
                                <!-- <input
                                  :disabled="isRedLabel === true"
                                  type="text"
                                  pattern="\d*"
                                  maxlength="4"
                                  placeholder=""
                                  v-mask="'####'"
                                  class="lb-number-motorcy text-center"
                                  v-model="license_plate_suffix"
                                /> -->
                                <!---->
                              </div>
                            </div>
                            <!---->
                          </div>
                          <!---->
                        </div>
                        <!---->
                        <!---->
                        <!---->
                        <div
                          class="container"
                          v-if="
                            license_plate_prefix != '' ||
                              license_plate_suffix != '' ||
                              isRedLabel === true
                          "
                        >
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-xs-12">
                              <div class="form-group from-cus">
                                <label>ชื่อลูกค้า</label>
                                <input
                                  type="text"
                                  maxlength="191"
                                  placeholder="คุณ "
                                  class="form-control"
                                  v-model="name"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6 col-md-6 col-xs-6">
                              <div class="form-group from-cus">
                                <label>เบอร์ติดต่อ</label>
                                <input
                                  type="text"
                                  pattern="\d*"
                                  placeholder="เบอร์ติดต่อ"
                                  maxlength="11"
                                  v-mask="'###-#######'"
                                  v-model="tel"
                                  class="form-control input-detail"
                                />
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-6">
                              <div class="form-group from-cus">
                                <label>ที่อยู่</label>
                                <div
                                  class="form-control click modal-container"
                                  style="overflow: hidden; text-overflow: ellipsis;"
                                  @click="showAddressModal = true"
                                >
                                  <span style="white-space: nowrap;"> {{ address }}  {{ subdistrictText ? 'ต.'+subdistrictText: ''  }} {{ districtText ? 'อ.'+districtText : '' }} {{ provinceText ? 'จ.'+provinceText : '' }} {{ zipcode }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6 col-md-6 col-xs-6">
                              <div class="form-group from-cus">
                                <label>เอกสาร</label>
                                <select
                                  class="form-control"
                                  v-model="document_type"
                                  ><option value="" selected="selected"
                                    >---- เลือก ----</option
                                  ><option value="1">เล่ม</option
                                  ><option value="2">สำเนา</option></select
                                >
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-6">
                              <div class="form-group from-cus">
                                <label>วันที่นัดรับ</label>
                                <br />
                                <datepicker
                                  :lang="th"
                                  :format="momentFormat"
                                  class="date-picker fix-height"
                                  v-model="appointment_date"
                                ></datepicker>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-xs-12">
                              <button
                                type="button"
                                @click="saveReceipt()"
                                :disabled="isProcessing === true"
                                class="btn btn-block  btn-lg btn-danger"
                              >
                                <i class="far fa-lg fa-fa-edit"></i>แก้ไข
                              </button>
                              <div class="text-danger mt-3">
                                <ul></ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tax Modal -->
    <div v-if="showTaxModal" class="modal fade show" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">กรณีขาดต่อภาษี</h4>
            <button
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
              class="close"
              @click="showTaxModal = false"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="row row-options2">
                  <div class="col-lg-12 col-md-12 col-xs-12">
                    วันที่ครบกำหนด
                  </div>
                  <div class="col-lg-12 col-md-12 col-xs-12">
                    <input
                      type="text"
                      attern="\d*"
                      maxlength="10"
                      placeholder="ว/ด/พ.ศ."
                      class="form-control input-detail"
                      v-mask="'##/##/####'"
                      v-model="cover_end_date"
                    />
                    <div
                      class="text-danger"
                      v-if="cover_end_date.length === 10 && renew_date !== null"
                    >
                      ขาดปี
                      <span
                        class="label label-info mr-1 mt-1 click"
                        @click="getFlashbackDate(3)"
                        >{{ getFlashbackYear(3) }}</span
                      ><span
                        class="label label-info mr-1 mt-1 click"
                        @click="getFlashbackDate(2)"
                        >{{ getFlashbackYear(2) }}</span
                      ><span
                        class="label label-info mr-1 mt-1 click"
                        @click="getFlashbackDate(1)"
                        >{{ getFlashbackYear(1) }}</span
                      ><span
                        class="label label-info mr-1 mt-1 click"
                        @click="getFlashbackDate(0)"
                        >{{ getFlashbackYear(0) }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row row-options2">
                  <div class="col-lg-12 col-md-12 col-xs-12">
                    วันที่ยื่นต่อภาษี
                    <!---->
                  </div>
                  <div class="col-lg-12 col-md-12 col-xs-12">
                    <datepicker
                      :lang="th"
                      :format="momentFormat"
                      class="date-picker"
                      v-model="renew_date"
                    ></datepicker>
                  </div>
                </div>
              </div>
            </div>
            <!---->
            <!---->
            <div class="row" style="padding-top: 5px;">
              <div class="col-md-12">
                <h3
                  v-if="isDiffMoreThan1Yr && isDiffMoreThan3Yrs === false"
                  class="text-danger text-center"
                >
                  ภาษีขาดเกิน 1 ปีต้องตรวจสภาพ !!
                </h3>
                <h3 v-if="isDiffMoreThan3Yrs" class="text-danger text-center">
                  ภาษีขาดเกิน 3 ปี !!
                </h3>
                <h3 class="text-danger text-center" v-if="isMoreThan90Days">
                  ยื่นล่วงหน้าเกิน 90 วัน ยังต่อภาษีไม่ได้
                </h3>
                <table
                  v-if="
                    cover_end_date != '' &&
                      registered_date != '' &&
                      isMoreThan90Days === false &&
                      isDiffMoreThan3Yrs === false
                  "
                  width="100%"
                  class="table table-sm m-b-2 mt-2"
                >
                  <thead>
                    <tr class="bg-primary text-white">
                      <td
                        colspan="3"
                        class="text-center"
                        style="font-size: 24px;"
                      >
                        ยอดสุทธิ
                        {{
                          (taxTotalAmount() + fineTotalAmount()).toLocaleString(
                            "th-TH",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )
                        }}
                        บาท
                      </td>
                    </tr>
                    <tr class="bg-warning text-white">
                      <td
                        colspan="3"
                        class="text-center"
                        style="font-size: 24px;"
                      >
                        ปัดเศษ
                        {{
                          roundupInteger(
                            taxTotalAmount() + fineTotalAmount()
                          ).toLocaleString("th-TH", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                        บาท
                      </td>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th width="20%" class="text-right"><b>ปี</b></th>
                      <th width="40%" class="text-right"><b>ภาษี</b></th>
                      <th width="40%" class="text-right"><b>ค่าปรับ</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(tax, index) in listOfTaxes" :key="tax.id">
                      <td class="text-right">
                        <input
                          type="checkbox"
                          v-model="tax.isChecked"
                          @change="onCheckBoxChange($event)"
                          :disabled="isDisabled(index)"
                        />
                        {{ tax.year }}
                      </td>

                      <td
                        class="text-right"
                        :class="!tax.isChecked ? 'text-notax' : ''"
                      >
                        {{
                          tax.amount.toLocaleString("th-TH", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </td>
                      <td
                        class="text-right"
                        :class="!tax.isChecked ? 'text-notax' : ''"
                      >
                        {{
                          tax.fine.toLocaleString("th-TH", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </td>
                    </tr>
                    <!-- <tr>
                      <td class="text-right">
                        <input type="checkbox" disabled="disabled" /> 2564
                      </td>
                      <td class="text-right">100.00</td>
                      <td class="text-right">23.00</td>
                    </tr>
                    <tr>
                      <td class="text-right">
                        <input type="checkbox" disabled="disabled" /> 2565
                      </td>
                      <td class="text-right">100.00</td>
                      <td class="text-right">11.00</td>
                    </tr>
                    <tr>
                      <td class="text-right"><input type="checkbox" /> 2566</td>
                      <td class="text-right">100.00</td>
                      <td class="text-right">0.00</td>
                    </tr> -->
                  </tbody>
                  <tfoot>
                    <tr>
                      <th class="text-right"><b>รวม</b></th>
                      <td class="text-right">
                        {{
                          taxTotalAmount().toLocaleString("th-TH", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          fineTotalAmount().toLocaleString("th-TH", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </td>
                    </tr>
                  </tfoot>
                  <tfoot></tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Address Modal -->
    <div
      v-if="showAddressModal"
      class="modal fade show"
      style="display: block;"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 id="myModalLabel" class="modal-title">ที่อยู่ลูกค้า</h4>
            <button
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
              class="close"
              @click="showAddressModal = false"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="form-group">
                  <h5>เลขประจำตัวผู้เสียภาษี</h5>
                  <input
                    type="text"
                    pattern="\d*"
                    maxlength="17"
                    placeholder=""
                    class="form-control"
                    v-mask="'#-####-#####-##-#'"
                    v-model="address_tax_no"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="form-group">
                  <h5>ที่อยู่</h5>
                  <input
                    type="text"
                    placeholder=""
                    v-model="address"
                    value=""
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="form-group">
                  <h5>จังหวัด</h5>
                  <v-select
                    v-model="address_province"
                    :options="masterProvince"
                    label="name"
                    @input="changeProvince"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="form-group">
                  <h5>อำเภอ</h5>
                  <v-select
                    v-model="address_district"
                    :options="masterDistrict"
                    label="name"
                    @input="changeDistrict"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="form-group">
                  <h5>ตำบล</h5>
                  <v-select
                    v-model="address_subdistrict"
                    :options="masterSubDistrict"
                    label="name"
                    @input="changeSubDistrict"
                  ></v-select>
                  <!-- <v-select
                    v-model="address_subdistrict"
                    :options="masterSubDistrict"
                    :reduce="(p) => p.id"
                    label="name"
                    @input="changeSubDistrict"
                  ></v-select> -->
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <h5>รหัสไปรษณีย์</h5>
                <input
                  type="text"
                  pattern="\d*"
                  maxlength="5"
                  placeholder="รหัสไปรษณีย์"
                  class="form-control"
                  v-mask="'#####'"
                  v-model="zipcode"
                />
              </div>
            </div>
          </div>
          <div class="modal-body hide-content"></div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="showAddressModal = false"
            >
              ตกลง
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- WSU Modal -->
    <div v-show="showWSUModal" class="modal fade show" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 id="myModalLabel" class="modal-title">ระยะคุ้มครอง พ.ร.บ.</h4>
            <span type="button" @click="showWSUModal = false">
              ×
            </span>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="row row-options2">
                  <div class="col-lg-12 col-md-12 col-xs-12">
                    วันที่เริ่มต้น
                  </div>
                  <div class="col-lg-12 col-md-12 col-xs-12">
                    <input
                      type="text"
                      pattern="\d*"
                      maxlength="10"
                      placeholder="ว/ด/พ.ศ."
                      class="form-control input-detail"
                      v-mask="'##/##/####'"
                      v-model="wsuStartDate"
                    />
                    <div>
                      <span
                        class="label label-info mr-1 mt-1 click"
                        @click="wsuToday()"
                      >
                        วันนี้
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row row-options2">
                  <div class="col-lg-12 col-md-12 col-xs-12">
                    วันที่สิ้นสุด
                  </div>
                  <div class="col-lg-12 col-md-12 col-xs-12">
                    <input
                      type="text"
                      pattern="\d*"
                      maxlength="10"
                      placeholder="ว/ด/พ.ศ."
                      class="form-control input-detail"
                      v-model="wsuEndDate"
                      v-mask="'##/##/####'"
                    />
                    <div>
                      <span
                        class="label label-info mr-1 mt-1 click"
                        @click="wsu1Yrs()"
                        >1 ปี</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <h4 class="text-center m-t-10">
                  <a
                    v-show="
                      wsuStartDate.length === 10 && wsuEndDate.length === 10
                    "
                    ><i
                      class="fas fa-minus-square text-danger click"
                      @click="increaseWsuDate()"
                    ></i></a
                  >&nbsp;&nbsp; คุ้มครอง {{ wsuDate }} วัน &nbsp;&nbsp;<a
                    v-show="
                      wsuStartDate.length === 10 && wsuEndDate.length === 10
                    "
                    ><i
                      class="fas fa-plus-square text-success click"
                      @click="decreaseWsuDate()"
                    ></i
                  ></a>
                </h4>
                <div class="row">
                  <div class="col-md-6 col-xs-6 text-right">
                    เบี้ย
                  </div>
                  <div class="col-md-6 col-xs-6 ">
                    {{
                      wsuTotal ? wsuTotal.toLocaleString("th-TH", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) : 0
                    }}
                    <!-- <label class="click"
                      ><input type="checkbox" /> ปัดสากล</label
                    >
                    <label class="click"
                      ><input type="checkbox" /> ปัดขึ้น</label
                    > -->
                  </div>
                  <div class="col-md-6 col-xs-6 text-right">
                    อากรแสตมป์
                  </div>
                  <div class="col-md-6 col-xs-6 ">
                    {{
                      wsuRevenueStamp ? wsuRevenueStamp.toLocaleString("th-TH", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) : 0
                    }}
                  </div>
                  <div class="col-md-6 col-xs-6 text-right">
                    ภาษีมูลค่าเพิ่ม
                  </div>
                  <div class="col-md-6 col-xs-6 ">
                    {{
                      wsuVat ? wsuVat.toLocaleString("th-TH", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) : 0
                    }}
                  </div>
                  <div class="col-md-6 col-xs-6 text-right text-info">
                    <h4>ยอดสุทธิ</h4>
                  </div>
                  <div class="col-md-6 col-xs-6 text-info">
                    <h4>
                      {{
                        wsuGrandTotal ? wsuGrandTotal.toLocaleString("th-TH", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) : 0
                      }}
                    </h4>
                  </div>
                  <div class="col-md-6 col-xs-6 text-right text-info">
                    <h4>ปัดเศษ</h4>
                  </div>
                  <div class="col-md-6 col-xs-6 text-info">
                    <h4>
                      {{
                        roundupInteger(wsuGrandTotal).toLocaleString("th-TH", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import router from "../router";
import axios from "axios";
import VueMask from "v-mask";
import kickMixin from "../mixins/kickMixin";
import Dropdown from "bootstrap-vue/src/components/dropdown";
import Select2 from "vue3-select2-component";
import Datepicker from "vue2-datepicker";
import moment from "moment";
import AnimatedNumber from "animated-number-vue";
import VueSuggestion from "vue-suggestion";
import itemTemplate from "./ItemTemplate2.vue";

Vue.use(VueSuggestion);
Vue.use(Dropdown);
Vue.use(VueMask);
Vue.component("Select2", Select2);

moment.locale("th");

export default {
  name: "document",
  mixins: [kickMixin],
  components: { Datepicker, AnimatedNumber },
  data() {
    return {
      isProcessing: false,
      item: {},
      searchedName: [],
      items: [],
      itemTemplate,

      showTaxModal: false,
      showAddressModal: false,
      showWSUModal: false,
      isMoreThan90Days: false,

      checkPrice: 0,
      wsuPrice: 0,
      taxPrice: 0,
      taxFinePrice: 0,
      servicePrice: 0,
      otherPrice: 0,

      duration: 500,

      cc: "",
      weight: "",

      isCheckPaymentEnable: false,
      isWSUPaymentEnable: false,
      isTaxPaymentEnable: false,
      isTaxFinePaymentEnable: false,
      isServicePaymentEnable: false,
      isOtherPaymentEnable: false,

      province: "",
      license_plate_prefix: "",
      license_plate_suffix: "",

      btnEvState: false,
      btnHybridState: false,
      btnJuristicState: false,
      isRedLabel: false,

      isDiffMoreThan1Yr: false,
      isDiffMoreThan3Yrs: false,

      registered_date: "",
      cover_end_date: "",
      renew_date: new Date(),

      wsuStartDate: "",
      wsuEndDate: "",
      wsuDate: 0,

      wsuTotal: 0,
      wsuRevenueStamp: 0,
      wsuVat: 0,
      wsuGrandTotal: 0,

      name: "",
      tel: "",
      document_type: "",
      address_tax_no: "",
      appointment_date: new Date(),

      address: "",
      zipcode: "",
      address_subdistrict: "",
      address_district: "",
      address_province: "",

      subdistrictText: "",
      districtText: "",
      provinceText: "",

      listOfTaxes: [],

      masterDistrict: [],
      masterSubDistrict: [],
      masterProvince: [],
      masterCarType: [
        { id: 0, name: "---- ประเภทรถ ----" },
        { id: 1, name: "[ รย.1 ] รถยนต์นั่งส่วนบุคคลไม่เกิน 7 คน" },
        { id: 2, name: "[ รย.2 ] รถยนต์นั่งส่วนบุคคลเกิน 7 คน" },
        { id: 3, name: "[ รย.3 ] รถยนต์บรรทุกส่วนบุคคล" },
        { id: 4, name: "[ รย.12 ] รถจักรยานยนต์ส่วนบุคคล" },
        { id: 5, name: "[ รย.13 ] รถแทรกเตอร์ที่ใช้ในการเกษตร" },
        { id: 6, name: "[ ขส.10 ] รถโดยสารประจำทาง (10-19)" },
        { id: 7, name: "[ ขส.30 ] รถโดยสารไม่ประจำทาง (30-39)" },
        { id: 8, name: "[ ขส.40 ] รถโดยสารส่วนบุคคล (40-49)" },
        { id: 9, name: "[ ขส.70 ] รถบรรทุกไม่ประจำทาง (70-79)" },
        { id: 10, name: "[ ขส.80 ] รถบรรทุกส่วนบุคคล (50-59) และ (80-99)" },
      ],

      now: moment()
        .add(543, "y")
        .format("DD/MM/YYYY"),

      selectedType: 0,
      selectedSubType: 0,

      momentFormat: {
        stringify: (date) => {
          return date
            ? moment(date)
                .add(543, "y")
                .format("D MMM YYYY")
            : null;
        },
        parse: (value) => {
          return value
            ? moment(value, "D MMM YYYY")
                .subtract(543, "y")
                .toDate()
            : null;
        },
      },

      th: {
        formatLocale: {
          firstDayOfWeek: 1,
          monthsShort: [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
          ],
          weekdaysMin: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        },
        monthBeforeYear: true,
      },

      masterCarSubType: [{ id: 0, name: "---- ประเภท พ.ร.บ. ----" }],

      masterCarSubType1: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        { id: 1, name: "[ 1.10 ] รถยนต์นั่งไม่เกิน 7 คน" },
        { id: 2, name: "[ 1.10E ] รถยนต์นั่งไม่เกิน 7 คน" },
        { id: 3, name: "[ 2.10 ] รถยนต์นั่งไม่เกิน 7 คน" },
        { id: 4, name: "[ 2.10E ] รถยนต์นั่งไม่เกิน 7 คน พลังงานไฟฟ้า" },
        { id: 5, name: "[ 3.10 ] รถยนต์นั่งไม่เกิน 7 คน" },
        { id: 6, name: "[ 3.10E ] รถยนต์นั่งไม่เกิน 7 คน พลังงานไฟฟ้า" },
        { id: 7, name: "[ 3.60 ] รับจ้าง/ให้เช่า" },
      ],
      masterCarSubType2: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        {
          id: 1,
          name:
            "[ 1.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 2,
          name:
            "[ 1.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 3,
          name:
            "[ 1.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 4,
          name:
            "[ 1.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 5,
          name:
            "[ 2.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 6,
          name:
            "[ 2.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 7,
          name:
            "[ 2.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 8,
          name:
            "[ 2.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 9,
          name:
            "[ 2.20E ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 10,
          name:
            "[ 2.20F ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 15-20 ที่นั่ง",
        },
        {
          id: 11,
          name:
            "[ 2.20G ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 20-40 ที่นั่ง",
        },
        {
          id: 12,
          name:
            "[ 2.20H ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 40 ที่นั่ง",
        },
        {
          id: 13,
          name:
            "[ 3.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 14,
          name:
            "[ 3.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 15,
          name:
            "[ 3.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 16,
          name:
            "[ 3.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 17,
          name:
            "[ 3.20E ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 18,
          name:
            "[ 3.20F ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 15-20 ที่นั่ง",
        },
        {
          id: 19,
          name:
            "[ 3.20G ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 20-40 ที่นั่ง",
        },
        {
          id: 20,
          name:
            "[ 3.20H ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 40 ที่นั่ง",
        },
      ],
      masterCarSubType3: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        { id: 1, name: "[ 1.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 2,
          name: "[ 1.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 3,
          name: "[ 1.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 4, name: "[ 1.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 5,
          name:
            "[ 1.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 6,
          name:
            "[ 1.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 7, name: "[ 1.50 ] หัวลากจูง" },
        { id: 8, name: "[ 1.60 ] รถพ่วง" },
        { id: 9, name: "[ 2.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 10,
          name: "[ 2.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 11,
          name: "[ 2.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 12, name: "[ 2.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 13,
          name:
            "[ 2.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 14,
          name:
            "[ 2.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 15, name: "[ 2.50 ] หัวลากจูง" },
        { id: 16, name: "[ 2.60 ] รถพ่วง" },
        { id: 17, name: "[ 3.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 18,
          name: "[ 3.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 19,
          name: "[ 3.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 20, name: "[ 3.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        { id: 21, name: "[ 3.50 ] หัวลากจูง" },
      ],
      masterCarSubType4: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        { id: 1, name: "[ 1.30A ] รถจักรยานยนต์ ไม่เกิน 75 ซีซี" },
        { id: 2, name: "[ 1.30B ] รถจักรยานยนต์ เกิน 75 ซีซี ถึง 125 ซีซี" },
        { id: 3, name: "[ 1.30C ] รถจักรยานยนต์ เกิน 125 ซีซี ถึง 150 ซีซี" },
        { id: 4, name: "[ 1.30D ] รถจักรยานยนต์ เกิน 150 ซีซี" },
        { id: 5, name: "[ 1.30E ] รถจักรยานยนต์ (พลังงานไฟฟ้า)" },
        {
          id: 6,
          name: "[ 1.71 ] รถยนต์สามล้อที่แปรสภาพมาจากรถจักรยานยนต์ (สกายแลป)",
        },
        { id: 7, name: "[ 2.30A ] รถจักรยานยนต์ ไม่เกิน 75 ซีซี" },
        { id: 8, name: "[ 2.30B ] รถจักรยานยนต์ เกิน 75 ซีซี ถึง 125 ซีซี" },
        { id: 9, name: "[ 2.30C ] รถจักรยานยนต์ เกิน 125 ซีซี ถึง 150 ซีซี" },
        { id: 10, name: "[ 2.30D ] รถจักรยานยนต์ เกิน 150 ซีซี" },
        { id: 11, name: "[ 2.30E ] รถจักรยานยนต์ (พลังงานไฟฟ้า)" },
        {
          id: 12,
          name: "[ 2.71 ] รถยนต์สามล้อที่แปรสภาพมาจากรถจักรยานยนต์ (สกายแลป)",
        },
        { id: 13, name: "[ 3.30A ] รถจักรยานยนต์ ไม่เกิน 75 ซีซี" },
        { id: 14, name: "[ 3.30B ] รถจักรยานยนต์ เกิน 75 ซีซี ถึง 125 ซีซี" },
        { id: 15, name: "[ 3.30C ] รถจักรยานยนต์ เกิน 125 ซีซี ถึง 150 ซีซี" },
        { id: 16, name: "[ 3.30D ] รถจักรยานยนต์ เกิน 150 ซีซี" },
        { id: 17, name: "[ 3.30E ] รถจักรยานยนต์ (พลังงานไฟฟ้า)" },
        {
          id: 18,
          name: "[ 3.71 ] รถยนต์สามล้อที่แปรสภาพมาจากรถจักรยานยนต์ (สกายแลป)",
        },
      ],
      masterCarSubType5: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        { id: 1, name: "[ 4.06 ] รถใช้งานเกษตรกรรมตามกฎหมายด้วยรถยนต์" },
        { id: 2, name: "[ 4.07 ] รถยนต์ประเภทอื่นๆ" },
      ],
      masterCarSubType6: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        {
          id: 1,
          name:
            "[ 1.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 2,
          name:
            "[ 1.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 3,
          name:
            "[ 1.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 4,
          name:
            "[ 1.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 5,
          name:
            "[ 2.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 6,
          name:
            "[ 2.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 7,
          name:
            "[ 2.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 8,
          name:
            "[ 2.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 9,
          name:
            "[ 2.20E ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 10,
          name:
            "[ 2.20F ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 15-20 ที่นั่ง",
        },
        {
          id: 11,
          name:
            "[ 2.20G ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 20-40 ที่นั่ง",
        },
        {
          id: 12,
          name:
            "[ 2.20H ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 40 ที่นั่ง",
        },
        {
          id: 13,
          name:
            "[ 3.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 14,
          name:
            "[ 3.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 15,
          name:
            "[ 3.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 16,
          name:
            "[ 3.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 17,
          name:
            "[ 3.20E ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 18,
          name:
            "[ 3.20F ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 15-20 ที่นั่ง",
        },
        {
          id: 19,
          name:
            "[ 3.20G ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 20-40 ที่นั่ง",
        },
        {
          id: 20,
          name:
            "[ 3.20H ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 40 ที่นั่ง",
        },
        { id: 21, name: "[ 4.07 ] รถยนต์ประเภทอื่นๆ" },
      ],
      masterCarSubType7: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        {
          id: 1,
          name:
            "[ 1.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 2,
          name:
            "[ 1.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 3,
          name:
            "[ 1.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 4,
          name:
            "[ 1.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 5,
          name:
            "[ 2.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 6,
          name:
            "[ 2.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 7,
          name:
            "[ 2.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 8,
          name:
            "[ 2.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 9,
          name:
            "[ 2.20E ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 10,
          name:
            "[ 2.20F ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 15-20 ที่นั่ง",
        },
        {
          id: 11,
          name:
            "[ 2.20G ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 20-40 ที่นั่ง",
        },
        {
          id: 12,
          name:
            "[ 2.20H ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 40 ที่นั่ง",
        },
        {
          id: 13,
          name:
            "[ 3.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 14,
          name:
            "[ 3.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 15,
          name:
            "[ 3.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 16,
          name:
            "[ 3.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 17,
          name:
            "[ 3.20E ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 18,
          name:
            "[ 3.20F ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 15-20 ที่นั่ง",
        },
        {
          id: 19,
          name:
            "[ 3.20G ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 20-40 ที่นั่ง",
        },
        {
          id: 20,
          name:
            "[ 3.20H ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 40 ที่นั่ง",
        },
        { id: 21, name: "[ 4.07 ] รถยนต์ประเภทอื่นๆ" },
      ],
      masterCarSubType8: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        {
          id: 1,
          name:
            "[ 1.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 2,
          name:
            "[ 1.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 3,
          name:
            "[ 1.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 4,
          name:
            "[ 1.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 5,
          name:
            "[ 2.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 6,
          name:
            "[ 2.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 7,
          name:
            "[ 2.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 8,
          name:
            "[ 2.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 9,
          name:
            "[ 2.20E ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 10,
          name:
            "[ 2.20F ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 15-20 ที่นั่ง",
        },
        {
          id: 11,
          name:
            "[ 2.20G ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 20-40 ที่นั่ง",
        },
        {
          id: 12,
          name:
            "[ 2.20H ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 40 ที่นั่ง",
        },
        {
          id: 13,
          name:
            "[ 3.20A ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 14,
          name:
            "[ 3.20B ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 15 ที่นั่ง ถึง 20 ที่นั่ง",
        },
        {
          id: 15,
          name:
            "[ 3.20C ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 20 ถึง 40 ที่นั่ง",
        },
        {
          id: 16,
          name:
            "[ 3.20D ] รถยนต์นั่งโดยสารเกิน 7 คน ขนาดที่นั่ง เกิน 40 ที่นั่ง",
        },
        {
          id: 17,
          name:
            "[ 3.20E ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) ไม่เกิน 15 ที่นั่ง",
        },
        {
          id: 18,
          name:
            "[ 3.20F ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 15-20 ที่นั่ง",
        },
        {
          id: 19,
          name:
            "[ 3.20G ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 20-40 ที่นั่ง",
        },
        {
          id: 20,
          name:
            "[ 3.20H ] รถยนต์นั่งโดยสาร ม.4 (วิ่ง อ.-อ. ใน จ.) เกิน 40 ที่นั่ง",
        },
        { id: 21, name: "[ 4.07 ] รถยนต์ประเภทอื่นๆ" },
      ],
      masterCarSubType9: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        { id: 1, name: "[ 1.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 2,
          name: "[ 1.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 3,
          name: "[ 1.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 4, name: "[ 1.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 5,
          name:
            "[ 1.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 6,
          name:
            "[ 1.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 7, name: "[ 1.50 ] หัวลากจูง" },
        { id: 8, name: "[ 1.60 ] รถพ่วง" },
        { id: 9, name: "[ 2.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 10,
          name: "[ 2.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 11,
          name: "[ 2.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 12, name: "[ 2.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 13,
          name:
            "[ 2.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 14,
          name:
            "[ 2.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 15, name: "[ 2.50 ] หัวลากจูง" },
        { id: 16, name: "[ 2.60 ] รถพ่วง" },
        { id: 17, name: "[ 3.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 18,
          name: "[ 3.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 19,
          name: "[ 3.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 20, name: "[ 3.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 21,
          name:
            "[ 3.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 22,
          name:
            "[ 3.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 23, name: "[ 3.50 ] หัวลากจูง" },
        { id: 24, name: "[ 3.60 ] รับจ้าง/ให้เช่า" },
        { id: 25, name: "[ 4.07 ] รถยนต์ประเภทอื่นๆ" },
      ],
      masterCarSubType10: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        { id: 1, name: "[ 1.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 2,
          name: "[ 1.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 3,
          name: "[ 1.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 4, name: "[ 1.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 5,
          name:
            "[ 1.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 6,
          name:
            "[ 1.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 7, name: "[ 1.50 ] หัวลากจูง" },
        { id: 8, name: "[ 1.60 ] รถพ่วง" },
        { id: 9, name: "[ 2.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 10,
          name: "[ 2.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 11,
          name: "[ 2.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 12, name: "[ 2.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 13,
          name:
            "[ 2.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 14,
          name:
            "[ 2.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 15, name: "[ 2.50 ] หัวลากจูง" },
        { id: 16, name: "[ 2.60 ] รถพ่วง" },
        { id: 17, name: "[ 3.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 18,
          name: "[ 3.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 19,
          name: "[ 3.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 20, name: "[ 3.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 21,
          name:
            "[ 3.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 22,
          name:
            "[ 3.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 23, name: "[ 3.50 ] หัวลากจูง" },
        { id: 24, name: "[ 4.07 ] รถยนต์ประเภทอื่นๆ" },
      ],
      masterCarSubType11: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        { id: 1, name: "[ 1.40A ] รถยนต์บรรทุกขนาดน้ำหนักรวม ไม่เกิน 3 ตัน" },
        {
          id: 2,
          name: "[ 1.40B ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 3 ตัน ถึง 6 ตัน",
        },
        {
          id: 3,
          name: "[ 1.40C ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 6 ตัน ถึง 12 ตัน",
        },
        { id: 4, name: "[ 1.40D ] รถยนต์บรรทุกขนาดน้ำหนักรวม เกิน 12 ตัน" },
        {
          id: 5,
          name:
            "[ 1.42A ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม ไม่เกิน 12 ตัน",
        },
        {
          id: 6,
          name:
            "[ 1.42B ] รถยนต์บรรทุกน้ำมันเชื้อเพลิงแก๊ส หรือกรด ขนาดน้ำหนักรวม เกิน 12 ตัน",
        },
        { id: 7, name: "[ 1.50 ] หัวลากจูง" },
        { id: 8, name: "[ 4.06 ] รถใช้งานเกษตรกรรมตามกฎหมายด้วยรถยนต์" },
        { id: 9, name: "[ 4.07 ] รถยนต์ประเภทอื่นๆ" },
      ],
      masterCarSubType12: [
        { id: 0, name: "---- ประเภท พ.ร.บ. ----" },
        { id: 1, name: "[ 1.10 ] รถยนต์นั่งไม่เกิน 7 คน" },
        { id: 2, name: "[ 1.10E ] รถยนต์นั่งไม่เกิน 7 คน (พลังงานไฟฟ้า)" },
        { id: 3, name: "[ 2.10 ] รถยนต์นั่งไม่เกิน 7 คน" },
        { id: 4, name: "[ 2.10E ] รถยนต์นั่งไม่เกิน 7 คน พลังงานไฟฟ้า" },
        { id: 5, name: "[ 3.10 ] รถยนต์นั่งไม่เกิน 7 คน" },
        { id: 6, name: "[ 3.10E ] รถยนต์นั่งไม่เกิน 7 คน พลังงานไฟฟ้า" },
      ],
    };
  },
  methods: {
  loadReceipt: function() {
      var localApp = this;
      axios
        .get("/api/receipt/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          let data = response.data.data;

          localApp.cover_end_date = moment(data.cal_cover_end_date).isValid() ? moment(data.cal_cover_end_date).add(543, 'y').format('DD/MM/YYYY') : "";
          localApp.registered_date = moment(data.cal_registered_date).isValid() ? moment(data.cal_registered_date).add(543, 'y').format('DD/MM/YYYY') : "";
          localApp.renew_date = moment(data.cal_renew_date).isValid() ?  moment(data.cal_renew_date).toDate() : new Date();

          localApp.wsuStartDate = data.cal_wsu_start_date ? moment(data.cal_wsu_start_date).add(543, 'y').format('DD/MM/YYYY') : "";
          localApp.wsuEndDate = data.cal_wsu_end_date ? moment(data.cal_wsu_end_date).add(543, 'y').format('DD/MM/YYYY') : "";
          localApp.cc = data.cal_cc ? data.cal_cc : ""
          localApp.weight = data.cal_weight ? data.cal_weight : ""

          localApp.btnEvState = data.cal_is_ev
          localApp.btnHybridState = data.cal_is_hybrid
          localApp.btnJuristicState = data.cal_is_juristic

          localApp.checkPrice = data.cal_check_price
          localApp.wsuPrice = data.cal_wsu_price
          localApp.taxPrice = data.cal_tax_price
          localApp.taxFinePrice = data.cal_tax_fine_price
          localApp.servicePrice = data.cal_service_price
          localApp.otherPrice = data.cal_other_price

          localApp.isCheckPaymentEnable = data.cal_is_check_price_enable
          localApp.isWSUPaymentEnable = data.cal_is_wsu_price_enable
          localApp.isTaxPaymentEnable = data.cal_is_tax_price_enable
          localApp.isTaxFinePaymentEnable = data.cal_is_tax_fine_price_enable
          localApp.isServicePaymentEnable = data.cal_is_service_enable
          localApp.isOtherPaymentEnable = data.cal_is_other_enable

          localApp.selectedType = data.cal_selected_type ? data.cal_selected_type : 0;
          localApp.selectedSubType = data.cal_selected_subtype ? data.cal_selected_subtype : 0;

          localApp.name = data.cal_name;
          localApp.tel = data.cal_tel;
          localApp.address_tax_no = data.cal_tax_id;
          localApp.address = data.cal_address;
          localApp.address_province = data.addressprovince ? data.addressprovince : "";
          localApp.address_district = data.addressdistrict ? data.addressdistrict : "";
          localApp.address_subdistrict = data.addresssubdistrict ? data.addresssubdistrict : "";
          localApp.zipcode = data.cal_postal_code;

          localApp.subdistrictText = data.addresssubdistrict ? data.addresssubdistrict.name : "";
          localApp.districtText = data.addressdistrict ? data.addressdistrict.name : "";
          localApp.provinceText = data.addressprovince ? data.addressprovince.name : "";

          localApp.license_plate_prefix = data.cal_license_plate_prefix;
          localApp.license_plate_suffix = data.cal_license_plate_suffix;
          localApp.isRedLabel = data.cal_is_red_label;
          localApp.province = data.getprovince ? data.getprovince : "";

          localApp.document_type = data.cal_document_type ? data.cal_document_type : "";
          localApp.appointment_date = moment(data.cal_appointment_date).isValid() ? moment(data.cal_appointment_date).toDate() : "";

          localApp.wsuTotal = data.cal_wsu_total;
          localApp.wsuRevenueStamp = data.cal_wsu_revenue_stamp;
          localApp.wsuVat = data.cal_wsu_vat;
          localApp.wsuGrandTotal = data.cal_wsu_grand_total;

          localApp.$refs.license_plate_suffix.searchText = localApp.license_plate_suffix;

          // if(localApp.$refs.license_plate_suffix != undefined) {
          //   localApp.$refs.license_plate_suffix.searchText = data.cal_license_plate_suffix;
          //   console.log('safe');
          // }
          // if(localApp.$refs.license_plate_suffix_motorcycle != undefined) {
            // localApp.$refs.license_plate_suffix.searchText = data.cal_license_plate_suffix;
            // console.log('fy');
          // }
          // localApp.recalculate();
        })
        .catch(function() {
          // localApp.kick();
        });
  },
  saveReceipt: function() {
      var localApp = this;
      if(this.tel === '') {
        alert('กรุณาใส่เบอร์โทรศัพท์');
        return;
      }
      if (!localApp.isProcessing && this.province !== '' && this.license_plate_suffix !== '' && this.license_plate_prefix !== '') {
        localApp.isProcessing = true;

        const dataToSend = {
          // cal_receipt_type: 2,

          cal_cover_end_date: moment(this.cover_end_date, "DD/MM/YYYY").subtract(543, 'y').format("YYYY-MM-DD HH:mm:ss"),
          cal_registered_date: moment(this.registered_date, "DD/MM/YYYY").subtract(543, 'y').format("YYYY-MM-DD HH:mm:ss"),
          cal_renew_date: this.renew_date,

          cal_wsu_start_date: moment(this.wsuStartDate, "DD/MM/YYYY").subtract(543, 'y').format("YYYY-MM-DD HH:mm:ss"),
          cal_wsu_end_date: moment(this.wsuEndDate, "DD/MM/YYYY").subtract(543, 'y').format("YYYY-MM-DD HH:mm:ss"),
          cal_cc: this.cc,
          cal_weight: this.weight,

          cal_is_ev: this.btnEvState,
          cal_is_hybrid: this.btnHybridState,
          cal_is_juristic: this.btnJuristicState,

          cal_check_price: this.checkPrice,
          cal_wsu_price: this.wsuPrice,
          cal_tax_price: this.taxPrice,
          cal_tax_fine_price: this.taxFinePrice,
          cal_service_price: this.servicePrice,
          cal_other_price: this.otherPrice,

          cal_is_check_price_enable: this.isCheckPaymentEnable,
          cal_is_wsu_price_enable: this.isWSUPaymentEnable,
          cal_is_tax_price_enable: this.isTaxPaymentEnable,
          cal_is_tax_fine_price_enable: this.isTaxFinePaymentEnable,
          cal_is_service_enable: this.isServicePaymentEnable,
          cal_is_other_enable: this.isOtherPaymentEnable,

          cal_selected_type: this.selectedType,
          cal_selected_subtype: this.selectedSubType,

          cal_name: this.name,
          cal_tel: this.tel,
          cal_tax_id: this.address_tax_no,
          cal_address: this.address,
          cal_province: this.address_province ? this.address_province.id : -1,
          cal_district: this.address_district? this.address_district.id : -1,
          cal_sub_district: this.address_subdistrict? this.address_subdistrict.id : -1,
          cal_postal_code: this.zipcode,

          cal_license_plate_prefix: this.license_plate_prefix,
          cal_license_plate_suffix: this.license_plate_suffix,
          cal_is_red_label: this.isRedLabel,
          cal_license_plate_province: this.province.id,

          cal_document_type: this.document_type,
          cal_appointment_date: this.appointment_date,

          name: this.name,
          tel: this.tel,

          cal_wsu_total: this.wsuTotal,
          cal_wsu_revenue_stamp: this.wsuRevenueStamp,
          cal_wsu_vat: this.wsuVat,
          cal_wsu_grand_total: this.wsuGrandTotal,
        };

        axios
          .patch("/api/updateReceipt/" + this.$route.params.id, dataToSend, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          })
          .then(function(response) {
            localApp.isProcessing = false;

            if (response.status == 200) {
              router.push("/receipt");
            }
          })
          .catch(function(error) {
            localApp.isProcessing = false;

            alert(error);
          });
      } else {
        alert('กรุณาตรวจสอบข้อมูลที่ท่านกรอก');
      }
    },
    generateTaxTable() {
      const coverEndDateObject = moment(this.cover_end_date, "DD/MM/YYYY");
      const renewDateObject = moment(this.renew_date, "DD/MM/YYYY").add(
        543,
        "years"
      ); //date picker
      // const diffDate = coverEndDateObject.diff(renewDateObject, "days");

      const thisYear = moment().year();
      const thisYearBuddha = moment()
        .add(543, "year")
        .year();
      const compareDate = moment(this.cover_end_date, "DD/MM/YYYY");
      compareDate.set("year", thisYear);
      const diff = compareDate.diff(
        moment(this.renew_date, "DD/MM/YYYY"),
        "days"
      );

      const diffYear = renewDateObject.diff(coverEndDateObject, "years");

      let row = 0;
      row = diffYear + 1;
      if (diff > 0) {
        if (coverEndDateObject.year() === thisYearBuddha) row = 1;
        else row += 1;
      }
      // let row = 0;
      // row = parseInt(diffDate / -360 + 1);
      // if (diff > 0) row += 1;

      this.listOfTaxes = [];
      for (let i = 1; i <= row; i++) {
        const yearText = coverEndDateObject.format("YYYY");
        const separateCoverEndDate = coverEndDateObject.add(1, "years");
        this.listOfTaxes.push({
          year: separateCoverEndDate.format("YYYY"),
          amount: this.getTaxPriceByYear(yearText),
          fine: this.getTaxFineByYear(yearText),
          isChecked: true,
        });
      }
    },
    calculateFinalPrice() {
      return (
        (this.isCheckPaymentEnable ? parseFloat(this.checkPrice) : 0) +
        (this.isWSUPaymentEnable ? parseFloat(this.wsuPrice) : 0) +
        (this.isTaxPaymentEnable ? parseFloat(this.taxPrice) : 0) +
        (this.isTaxFinePaymentEnable ? parseFloat(this.taxFinePrice) : 0) +
        (this.isServicePaymentEnable ? parseFloat(this.servicePrice) : 0) +
        (this.isOtherPaymentEnable ? parseFloat(this.otherPrice) : 0)
      );
    },
    roundupInteger(number) {
      return Math.ceil(number / 10) * 10;
    },
    onCheckBoxChange() {
      this.$nextTick(() => {
        let taxTotal = 0;
        let fineTotal = 0;

        this.listOfTaxes.forEach((element) => {
          if (element.isChecked) {
            taxTotal += element.amount;
            fineTotal += element.fine;
          }
        });
        this.taxPrice = parseFloat(taxTotal).toFixed(2);
        this.taxFinePrice = parseFloat(fineTotal).toFixed(2);
      });
    },
    taxTotalAmount() {
      const extraCar = 30;
      const extraMtc = 20;
      
      let taxTotal = 0;
      if(this.selectedType == 4){
        taxTotal += extraMtc;
      }
      else{
        taxTotal += extraCar;
      }

      this.listOfTaxes.forEach((element) => {
        if (element.isChecked) taxTotal += element.amount;
      });

      return this.btnJuristicState ? taxTotal * 2 : taxTotal;
      // return this.listOfTaxes.reduce( (previousValue, item) => {
      //   previousValue + item.amount
      //   }, 0)
    },
    fineTotalAmount() {
      let fineTotal = 0;
      this.listOfTaxes.forEach((element) => {
        if (element.isChecked) fineTotal += element.fine;
      });

      // this.taxFinePrice = fineTotal;
      return this.btnJuristicState ? fineTotal * 2 : fineTotal;
      // return this.listOfTaxes.reduce( (previousValue, item) => {
      //   previousValue + item.fine
      // }, 0)
    },
    formatToPrice(value) {
      return `${value.toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
    getCarSubType() {
      let returnData = this.masterCarSubType;
      if (this.selectedType == 1) {
        returnData = this.masterCarSubType1;
      } else if (this.selectedType == 2) {
        returnData = this.masterCarSubType2;
      } else if (this.selectedType == 3) {
        returnData = this.masterCarSubType3;
      } else if (this.selectedType == 4) {
        returnData = this.masterCarSubType4;
      } else if (this.selectedType == 5) {
        returnData = this.masterCarSubType5;
      } else if (this.selectedType == 6) {
        returnData = this.masterCarSubType6;
      } else if (this.selectedType == 7) {
        returnData = this.masterCarSubType7;
      } else if (this.selectedType == 8) {
        returnData = this.masterCarSubType8;
      } else if (this.selectedType == 9) {
        returnData = this.masterCarSubType9;
      } else if (this.selectedType == 10) {
        returnData = this.masterCarSubType10;
      } else if (this.selectedType == 11) {
        returnData = this.masterCarSubType11;
      } else if (this.selectedType == 12) {
        returnData = this.masterCarSubType12;
      } else {
        returnData = this.masterCarSubType;
      }

      return returnData;
    },
    getProvince: function() {
      var localApp = this;
      axios
        .get("/api/master/province", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterProvince = response.data.data;
            // localApp.masterProvince.forEach((obj) =>
            //   localApp.renameKey(obj, "name", "label")
            // );
          }
        })
        .catch(function() {
          // localApp.kick();
        });
    },
    renameKey(obj, oldKey, newKey) {
      obj[newKey] = obj[oldKey];
      delete obj[oldKey];
    },
    myChangeEvent() {},
    onTypeChange(e) {
      const selectedType = e.target.value;
      if(selectedType === '4'){
        this.checkPrice = 60;
      }
      else{
        this.checkPrice = 200;
      }
      this.recalculate();
    },
    onSubTypeSelected(){
    },
    getCheckPrice() {
      return this.isCheckPaymentEnable || this.checkPrice === ""
        ? this.checkPrice
        : 0;
    },
    getWsuPrice() {
      return this.isWSUPaymentEnable || this.wsuPrice === ""
        ? this.wsuPrice
        : 0;
    },
    getServicePrice() {
      return this.isServicePaymentEnable || this.servicePrice === ""
        ? this.servicePrice
        : 0;
    },
    getOtherPrice() {
      return this.isOtherPaymentEnable || this.otherPrice === ""
        ? this.otherPrice
        : 0;
    },
    getTaxPriceByYear(year) {
      if (this.selectedType === 1 && this.selectedSubType === 1) {
        const discount = this.getTaxDiscountPercentByYear(year);
        if (this.cc > 0 && this.cc <= 600) {
          return this.cc * 0.5 * discount;
        } else if (this.cc > 600 && this.cc < 1800) {
          return (this.cc * 1.5 - 600) * discount;
        } else if (this.cc > 1800) {
          return (this.cc * 4 - 5100) * discount;
        } else {
          return 0;
        }
      } else if (this.selectedType == 3 && this.selectedSubType === 1) {
        if (this.cc > 500 && this.cc <= 750) {
          return 450;
        } else if (this.weight > 700 && this.weight <= 1000) {
          return 600;
        } else if (this.weight > 1000 && this.weight <= 1250) {
          return 750;
        } else if (this.weight > 1250 && this.weight <= 1500) {
          return 900;
        } else if (this.weight > 1500 && this.weight <= 1750) {
          return 1050;
        } else if (this.weight > 1750 && this.weight <= 2000) {
          return 1350;
        } else if (this.weight > 2000 && this.weight <= 25000) {
          return 1650;
        } else {
          return 0;
        }
      } else if (this.selectedType == 4) {
        return 100;
      }
    },
    getTaxFineByYear(year) {
      const renewDateObject = moment(this.renew_date, "DD/MM/YYYY").add(
        543,
        "years"
      );
      const coverEndDateObject = moment(this.cover_end_date, "DD/MM/YYYY");
      coverEndDateObject.set("year", year);
      let monthNo = 0;
      monthNo = renewDateObject.diff(coverEndDateObject, "months");
      const diffDate = coverEndDateObject.diff(renewDateObject, "days");
      if (diffDate > 0) {
        return 0;
      } else {
        if (coverEndDateObject.date() < renewDateObject.date()) {
          //เลยวันครบกำหนด
          if (monthNo === 0) monthNo = 1;
          else monthNo += 1;
        } else if (coverEndDateObject.date() === renewDateObject.date()) {
          //พอดีวันครบกำหนด
          if (monthNo === 0) monthNo = 0;
        } else if (coverEndDateObject.date() > renewDateObject.date()) {
          //ก่อนวันครบกำหนด
          if (monthNo === 0) monthNo = 0;
          else monthNo += 1;
        }
      }

      return this.getTaxPriceByYear(year) * monthNo * 0.01;
    },
    getTaxDiscountPercentByYear(year) {
      const registeredDateObject = moment(this.registered_date, "DD/MM/YYYY");
      const coverEndDateObject = moment(this.cover_end_date, "DD/MM/YYYY");
      coverEndDateObject.set("year", year);

      let diff = coverEndDateObject.diff(registeredDateObject, "months");

      if (diff >= 12 * 5 && diff < 12 * 6) {
        return 0.9;
      } else if (diff >= 12 * 6 && diff < 12 * 7) {
        return 0.8;
      } else if (diff >= 12 * 7 && diff < 12 * 8) {
        return 0.7;
      } else if (diff >= 12 * 8 && diff < 12 * 9) {
        return 0.6;
      } else if (diff >= 12 * 9) {
        return 0.5;
      } else {
        return 1;
      }
    },
    getFlashbackDate(year) {
      const momentDate = moment(this.cover_end_date, "DD/MM/YYYY");
      momentDate.set("year", moment().year() - year + 543);
      this.cover_end_date = momentDate.format("DD/MM/YYYY");
    },
    getFlashbackYear(year) {
      return (
        moment()
          .subtract(year, "years")
          .year() + 543
      );
    },
    getTaxDiscountPercent() {
      const registeredDateObject = moment(this.registered_date, "DD/MM/YYYY");
      const coverEndDateObject = moment(this.cover_end_date, "DD/MM/YYYY");
      let diff = coverEndDateObject.diff(registeredDateObject, "months");

      if (diff === 12 * 5) {
        return 0.9;
      } else if (diff === 12 * 6) {
        return 0.8;
      } else if (diff === 12 * 7) {
        return 0.7;
      } else if (diff === 12 * 8) {
        return 0.6;
      } else if (diff >= 12 * 9) {
        return 0.5;
      } else {
        return 1;
      }
    },
    formatRenewDate(){
      return moment(this.renew_date).add(543, 'y').format("DD/MM/YYYY");
    },
    recalculate() {
      const registeredDateObject = moment(this.registered_date, "DD/MM/YYYY");
      const coverEndDateObject = moment(this.cover_end_date, "DD/MM/YYYY");
      const renewDateObject = moment(this.renew_date, "DD/MM/YYYY").add(
        543,
        "years"
      ); //date picker
      const coverWsuStartDateObject = moment(this.wsuStartDate, "DD/MM/YYYY");
      const coverWsuEndDateObject = moment(this.wsuEndDate, "DD/MM/YYYY");

      if (
        registeredDateObject.isValid() &&
        coverEndDateObject.isValid() &&
        renewDateObject.isValid()
      ) {
        //Check if extends more than 90 days
        // const diffDate = coverEndDateObject.diff(renewDateObject, "days");
        const diffMonth = coverEndDateObject.diff(renewDateObject, "months");
        if (diffMonth >= 3) {
          this.isMoreThan90Days = true;
        } else {
          this.isMoreThan90Days = false;
        }
        //

        //Calculate tax table
        this.generateTaxTable();
        //

        //If 1.10 Calculate tax
        if (this.selectedType === 1 && this.selectedSubType === 1) {
          this.taxPrice = parseFloat(this.taxTotalAmount()).toFixed(2);
          this.taxFinePrice = parseFloat(this.fineTotalAmount()).toFixed(2);

          const roundupTax = this.roundupInteger(
            parseFloat(this.taxTotalAmount()) +
              parseFloat(this.fineTotalAmount())
          );

          this.taxPrice = roundupTax - parseFloat(this.fineTotalAmount());
        }
        //
        else if (this.selectedType == 3 && this.selectedSubType === 1) {
          this.taxPrice = parseFloat(this.taxTotalAmount()).toFixed(2);
          this.taxFinePrice = parseFloat(this.fineTotalAmount()).toFixed(2);

          const roundupTax = this.roundupInteger(
            parseFloat(this.taxTotalAmount()) +
              parseFloat(this.fineTotalAmount())
          );

          this.taxPrice = roundupTax - parseFloat(this.fineTotalAmount());
        } else if (this.selectedType == 4) {
          this.taxPrice = parseFloat(this.taxTotalAmount()).toFixed(2);
          this.taxFinePrice = parseFloat(this.fineTotalAmount()).toFixed(2);

          const roundupTax = this.roundupInteger(
            parseFloat(this.taxTotalAmount()) +
              parseFloat(this.fineTotalAmount())
          );

          this.taxPrice = roundupTax - parseFloat(this.fineTotalAmount());
        }
      }

      if (
        coverWsuStartDateObject.isValid() &&
        coverWsuEndDateObject.isValid()
      ) {
        let wsuYearPrice = 0;

        if (
          (this.selectedType === 1 && this.selectedSubType === 1) ||
          (this.selectedType == 3 && this.selectedSubType === 1)
        ) {
          if (this.selectedType === 1) {
            wsuYearPrice = 600;
          } else if (this.selectedType == 3) {
            wsuYearPrice = 900;
          } else if (this.selectedType == 8) {
            wsuYearPrice = 1100;
          } else {
            wsuYearPrice = 600;
          }
        } else if (this.selectedType === 4) {
          const extra = 50;
          if (this.selectedSubType === 1) {
            wsuYearPrice = 150 + extra;
          } else if (this.selectedSubType == 2) {
            wsuYearPrice = 300 + extra;
          } else if (this.selectedSubType == 3) {
            wsuYearPrice = 400 + extra;
          } else if (this.selectedSubType == 4) {
            wsuYearPrice = 600 + extra;
          }  else {
            wsuYearPrice = 600;
          }
        }

        const perday = parseFloat(wsuYearPrice / 365);
        const total = parseInt(this.wsuDate) * parseFloat(perday);

        const revenueStamp = Math.ceil(total * 0.004);
        const vat = (total + parseInt(revenueStamp)) * 0.07;
        const roundUpVat = Math.round(vat * 100) / 100;
        const grandTotal = parseFloat(total + revenueStamp + roundUpVat);

        this.wsuTotal = total;
        this.wsuRevenueStamp = revenueStamp;
        this.wsuVat = roundUpVat;
        this.wsuGrandTotal = grandTotal;

        // this.wsuPrice = parseFloat(grandTotal).toFixed(2);
        this.wsuPrice = this.roundupInteger(grandTotal).toFixed(2);
      }
    },
    isDisabled(index) {
      if (this.listOfTaxes.length === 1) {
        return true;
      } else {
        if (
          this.listOfTaxes[index + 1] &&
          this.listOfTaxes[index + 1].isChecked === true
        )
          return true;
        //ถ้าข้างล่างติ้ก ให้ปิด
        else if (
          this.listOfTaxes[index - 1] &&
          this.listOfTaxes[index - 1].isChecked === false
        )
          return true;
        //ถ้าข้างบนไม่ได้ติ๊ก ให้ปิด
        else {
          if (index === 0) return true;
          else return false;
        }
      }
      // else{
      //   if((this.listOfTaxes[index+1] && (this.listOfTaxes[index+1].isChecked === true)))
      //     return true;
      //   else
      //     if(index === 0) return true;
      //     else return false
      // }
    },
    wsuToday() {
      this.wsuStartDate = moment()
        .add(543, "year")
        .format("DD/MM/YYYY");
      this.recalculate();
    },
    wsu1Yrs() {
      if (this.wsuStartDate.length === 10) {
        const wsuStartDateObject = moment(this.wsuStartDate, "DD/MM/YYYY");
        if (wsuStartDateObject.isValid()) {
          this.wsuEndDate = wsuStartDateObject
            .add(1, "year")
            .format("DD/MM/YYYY");
        }
      }
      this.recalculate();
    },
    increaseWsuDate() {
      const wsuStartDateObject = moment(this.wsuStartDate, "DD/MM/YYYY");
      const wsuEndDateObject = moment(this.wsuEndDate, "DD/MM/YYYY");

      if (
        this.wsuDate > 1 &&
        wsuStartDateObject.isValid() &&
        wsuEndDateObject.isValid()
      ) {
        const diffDate = wsuEndDateObject.diff(wsuStartDateObject, "days");
        if (diffDate > 0) {
          this.wsuDate--;
          this.wsuEndDate = wsuEndDateObject
            .subtract(1, "days")
            .format("DD/MM/YYYY");
        }
      }
      this.recalculate();
    },
    decreaseWsuDate() {
      const wsuStartDateObject = moment(this.wsuStartDate, "DD/MM/YYYY");
      const wsuEndDateObject = moment(this.wsuEndDate, "DD/MM/YYYY");

      if (
        this.wsuDate > 0 &&
        wsuStartDateObject.isValid() &&
        wsuEndDateObject.isValid()
      ) {
        const diffDate = wsuEndDateObject.diff(wsuStartDateObject, "days");
        if (diffDate > 0) {
          this.wsuDate++;
          this.wsuEndDate = wsuEndDateObject
            .add(1, "days")
            .format("DD/MM/YYYY");
        }
      }
      this.recalculate();
    },
    setLabel(item) {
      if (item.license_plate.includes("-")) {
        var lp = item.license_plate.split("-");
        if (lp.length === 2) {
          return lp[1];
        }
      }
      return item.license_plate;
    },
    fillLicensePlate(licensePlate) {
      const plate = (licensePlate || "").trim();
      if (!plate) {
        return;
      }

      if (plate.includes("-")) {
        const parts = plate.split("-");
        this.license_plate_prefix = (parts.shift() || "").trim();
        this.license_plate_suffix = parts.join("-").trim();
      } else {
        const compactPlate = plate.replace(/\s+/g, "");
        const letters = compactPlate.replace(/[0-9]/g, "");
        const numbers = compactPlate.replace(/[^0-9]/g, "");

        if (letters && numbers) {
          this.license_plate_prefix = letters;
          this.license_plate_suffix = numbers;
        } else if (numbers) {
          this.license_plate_prefix = "";
          this.license_plate_suffix = numbers;
        } else {
          this.license_plate_prefix = compactPlate;
          this.license_plate_suffix = "";
        }
      }
    },
    itemSelected(item) {
      this.name = item.name;
      this.tel = item.tel;
      this.province = item.getprovince ? item.getprovince : item.province_plate;
      this.$forceUpdate();
      this.fillLicensePlate(item.license_plate);
    },
    inputChange(text) {
      this.license_plate_suffix = text;
      if (text.length >= 1 && text.length <= 4) {
        this.searchByLicensePlateSuffix(text);
      }
    },
    searchByLicensePlateSuffix: function(text) {
      var localApp = this;
      axios
        .get(
          "/api/receipt/search/license-suffix" +
            "?keyword=" +
            text,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.searchedName = response.data.data;
          localApp.items = localApp.searchedName;
          // localApp.items = localApp.searchedName.filter((item) =>
          //   item.name.includes(text)
          // );
        })
        .catch(function() {
          localApp.kick();
        });
    },
    changeProvince(event) {
      var localApp = this;
      this.provinceText = event.name;

      axios
        .get("/api/master/district/" + event.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterDistrict = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    changeDistrict(event) {
      var localApp = this;
      this.districtText = event.name;

      axios
        .get("/api/master/subdistrict/" + event.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterSubDistrict = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    changeSubDistrict(event) {
      var localApp = this;
      this.subdistrictText = event.name;

      axios
        .get("/api/master/postal/" + event.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.zipcode = response.data.data[0].code;
          }
        })
        .catch(function() {
          localApp.kick();
          // alert("โปรดระบุข้อมูล จังหวัด อำเภอ และตำบล");
        });
    },
  },
  watch: {
    selectedSubType() {
      this.$refs.license_plate_suffix_m.searchText = this.license_plate_suffix;
      
      this.recalculate();
    },
    checkPrice() {
      // if (val > 0) this.isCheckPaymentEnable = true;
      // this.recalculate();
    },
    wsuPrice() {
      // if (val > 0) this.isWSUPaymentEnable = true;
      // this.recalculate();
    },
    taxPrice() {
      // if (val > 0) this.isTaxPaymentEnable = true;
      // this.recalculate();
    },
    taxFinePrice() {
      // if (val > 0) this.isTaxFinePaymentEnable = true;
      // this.recalculate();
    },
    servicePrice() {
      // if (val > 0) this.isServicePaymentEnable = true;
      // this.recalculate();
    },
    otherPrice() {
      // if (val > 0) this.isOtherPaymentEnable = true;
      // this.recalculate();
    },
    cc(val) {
      if (val.length >= 3) {
        this.recalculate();
      }
    },
    weight(val) {
      if (val.length >= 3) {
        this.recalculate();
      }
    },
    registered_date: function(val) {
      if (val.length === 10) {
        //Set cover end date
        const registeredDateObject = moment(val, "DD/MM/YYYY");
        const renewDateObject = moment(this.renew_date, "DD/MM/YYYY");
        const date = registeredDateObject.format("DD");
        const month = registeredDateObject.format("MM");
        const year = moment().year();
        let displayYear = moment(this.cover_end_date, "DD/MM/YYYY").year();
        // let displayYear = year + 543;

        const coverEndDateObject = moment(
          date + "/" + month + "/" + year,
          "DD/MM/YYYY"
        );

        const diffDate = coverEndDateObject.diff(renewDateObject, "days");
        if (diffDate > 90) {
          coverEndDateObject.subtract(1, "years");
          displayYear -= 1;
        }

        const coverEndDateString = date + "/" + month + "/" + displayYear;

        if (coverEndDateObject.isValid())
          this.cover_end_date = coverEndDateString;

        this.recalculate();
      }
    },
    cover_end_date(val) {
      if (val.length === 10) {
        const coverEndDateObject = moment(this.cover_end_date, "DD/MM/YYYY");
        const renewDateObject = moment(this.renew_date, "DD/MM/YYYY").add(
          543,
          "years"
        );

        const dateDiffInMonth = renewDateObject.diff(
          coverEndDateObject,
          "months"
        );
        //Check if more than 1 years
        if (dateDiffInMonth >= 12) {
          if (renewDateObject.date() === coverEndDateObject.date())
            this.isDiffMoreThan1Yr = false;
          else this.isDiffMoreThan1Yr = true;
        } else this.isDiffMoreThan1Yr = false;
        //

        //Check if more than 3 years
        if (renewDateObject.diff(coverEndDateObject, "months") >= 36) {
          if (renewDateObject.date() === coverEndDateObject.date())
            this.isDiffMoreThan3Yrs = false;
          else this.isDiffMoreThan3Yrs = true;
        } else this.isDiffMoreThan3Yrs = false;
        //
        const registeredDateObject = moment(this.registered_date, "DD/MM/YYYY");
        registeredDateObject.set("date", coverEndDateObject.date());
        registeredDateObject.set("month", coverEndDateObject.month());
        this.registered_date = registeredDateObject.format("DD/MM/YYYY");

        this.recalculate();
      }
    },
    renew_date() {
      this.recalculate();
    },
    btnEvState() {
      this.recalculate();
    },
    btnHybridState() {
      this.recalculate();
    },
    btnJuristicState() {
      this.recalculate();
    },
    wsuStartDate() {
      const wsuStartDateObject = moment(this.wsuStartDate, "DD/MM/YYYY");
      const wsuEndDateObject = moment(this.wsuEndDate, "DD/MM/YYYY");

      if (wsuStartDateObject.isValid() && wsuEndDateObject.isValid()) {
        const diffDate = wsuEndDateObject.diff(wsuStartDateObject, "days");
        if (diffDate > 0) {
          this.wsuDate = diffDate;
        }
      }

      this.recalculate();
    },
    wsuEndDate() {
      const wsuStartDateObject = moment(this.wsuStartDate, "DD/MM/YYYY");
      const wsuEndDateObject = moment(this.wsuEndDate, "DD/MM/YYYY");

      if (wsuStartDateObject.isValid() && wsuEndDateObject.isValid()) {
        const diffDate = wsuEndDateObject.diff(wsuStartDateObject, "days");
        if (diffDate > 0) {
          this.wsuDate = diffDate;
        }
      }

      this.recalculate();
    },
    isCheckPaymentEnable(){

    },
    isWSUPaymentEnable(){

    },
    isTaxPaymentEnable(){
      this.recalculate();
    },
    isTaxFinePaymentEnable(){
      this.recalculate();
    },
    isServicePaymentEnable(){

    },
    isOtherPaymentEnable(){

    },
  },
  mounted() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.loadReceipt();
    }
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.getProvince();
    }
  },
};
</script>
<style>
[v-cloak] > * {
  display: none;
}

.ready-scan {
  font-size: 48px;
  color: #000;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 5px 5px 5px 5px;
  -webkit-border-radius: 5px 5px 5px 5px;
  -webkit-card-shadow: 10px 10px 5px -6px rgba(0, 0, 0, 0.53);
  -moz-card-shadow: 10px 10px 5px -6px rgba(0, 0, 0, 0.53);
}

.red-label {
  background-color: #e02214 !important;
}

.red-label input {
  border-color: #000;
}

.bt-red-label {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 25px;
  height: 25px;
  border-radius: 12.5px;
  background-color: #e02214;
  cursor: pointer;
}

.bt-white-label {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 25px;
  height: 25px;
  border-radius: 12.5px;
  background-color: #fff;
  cursor: pointer;
}

.btn-qrcode {
  position: absolute;
  right: 20px;
  cursor: pointer;
  padding: 5px 10px 5px 10px;
  color: black;
}

.btn-qrcode:hover {
  background-color: #1b4489;
  color: white;
}

.from-cus label {
  color: #fff;
}

.ip-qrcode {
  position: absolute;
  left: 0px;
  width: 1px;
  height: 1px;
  background-color: #1b4489;
  color: #1b4489;
  border: 0px;
  cursor: pointer;
}

.total-price {
  color: #fff;
}

.form-control .option-logo {
  padding: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #eee;
  background-color: #eee;
  border-radius: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.option-logo.active {
  /* background-color: #F5B041; */
  transition: all 0.3s ease 0s;
  border: none;
}

.option-logo:hover {
  /* background-color: #F5B041; */
  transition: all 0.3s ease 0s;
  border: none;
}

.label-price {
  width: 100%;
  border-radius: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 64px;
}

.row-options {
  border-width: 1px;
  padding-top: 5px;
  padding-bottom: 2px;
  margin-bottom: 1px;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
}

.form-label {
  border: none;
  background: none;
  font-size: 18px;
  padding-left: 0px;
  cursor: pointer;
  color: #fff;
}

.form-label:hover {
  font-size: 20px;
}

.row-options2 {
  margin-bottom: 8px;
}

.click {
  cursor: pointer;
}

.row-options:hover {
  font-size: 20px;
}

.input-detail.error {
  border-color: red;
  border-width: 2px;
}

.est-box {
  padding: 30px 20px 20px 20px;
  border-top: solid 1px rgba(255, 255, 255, 0.5);
  border-radius: 5px;
  overflow: hidden;
  transition: all 0.5s ease;
  background-color: #2dce89;
  /* background: linear-gradient(to bottom, #3399ff 0%, #66ccff 50%); */
}

.text-uncheck {
  color: #eee;
}

.text-pink {
  color: #d81b60;
}

.text-check {
  color: #d81b60;
  -webkit-animation-name: toCehck;
  /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 1s;
  /* Safari 4.0 - 8.0 */
  animation-name: toCehck;
  animation-duration: 1s;
}

/* Safari 4.0 - 8.0 */

@-webkit-keyframes toCehck {
  from {
    color: #eee;
    font-size: 24px;
  }
  to {
    color: #d81b60;
  }
}

/* Standard syntax */

@keyframes toCehck {
  from {
    color: #eee;
    font-size: 24px;
  }
  to {
    color: #d81b60;
  }
}

.label-number {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  padding: 10px 10px 10px 10px;
  border: solid 2px black;
  width: 65%;
  border-radius: 5px;
  margin-bottom: 10px;
}

.label-number-motorcy {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  padding: 10px 10px 10px 10px;
  border: solid 2px black;
  width: 50%;
  border-radius: 5px;
  margin-bottom: 10px;
}

@media screen and (max-width: 1100px) {
  .label-number {
    width: 100%;
  }
}

@media screen and (max-width: 1200px) {
  .label-number-motorcy {
    width: 75%;
  }
}

@media screen and (max-width: 600px) {
  .label-number-motorcy {
    width: 95%;
  }
}

.lb-char {
  width: 80px;
  border: solid 1px #aaa;
  border-radius: 5px;
}

.lb-number {
  width: 120px;
  border: solid 1px #aaa;
  border-radius: 5px;
}

.lb-number .vs__input {
  width: 110px;
  border: 0;
}

.vs__selected {
  margin: 0;
  padding: 0;
  border: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  justify-content: center;
}

.vs__selected input,
.vs__selected input:focus {
  border: 0;
  outline: none;
  width: 100%;
}

.vs__input-group {
  z-index: 99999;
}
::placeholder {
  color: #8898aa;
}
.vs--searchable {
  border-radius: 0.375rem;
}

.vs__input {
  border: none;
  background: white;
}

.vs__dropdown-toggle {
  padding: 0;
}

.lb-char-motorcy {
  width: 100px;
  border: solid 1px #aaa;
  border-radius: 5px;
  font-size: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* .lb-number-motorcy {
  width: 100px;
  border: solid 1px #aaa;
  border-radius: 5px;
  font-size: 30px;
  margin-top: 10px;
} */

.lb-number-motorcy {
  width: 100px;
  border: solid 1px #aaa;
  border-radius: 5px;
  font-size: 30px;
  margin-top: 10px;
}

.lb-number-motorcy .vs__input {
  width: 90px;
  border: 0;
}

/* Enter and leave animations can use different */

/* durations and timing functions.              */

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
    .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */

 {
  transform: translateX(10px);
  opacity: 0;
}

.loader {
  border: 3px solid #d6d6d6;
  /* Light grey */
  border-top: 3px solid #ffffff;
  /* Blue */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-container:hover {
  background-color: #ff851b;
}

.autocomplete-list {
  z-index: 9999;
  overflow: auto;
  min-width: 250px;
  max-height: 300px;
  margin: 0;
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 0;
  border: 1px solid #eee;
  list-style: none;
  border-radius: 4px;
  background-color: #eee;
}
.autocomplete-list li {
  cursor: pointer;
  font-size: 16px;
  margin: 0;
  padding: 8px 15px;
  border-bottom: 1px solid #f5f5f5;
}
.autocomplete-list li:last-child {
  border-bottom: 0;
}
.autocomplete-list li:hover,
.autocomplete-list li.active {
  color: #3c763d;
  background-color: #dff0d8;
}

.autocomplete-list-name {
  position: absolute;
  width: 100%;
  z-index: 9999;
  overflow: auto;
  min-width: 250px;
  max-height: 300px;
  margin: 0;
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 0;
  border: 1px solid #eee;
  list-style: none;
  border-radius: 4px;
  background-color: #eee;
}
.autocomplete-list-name li {
  cursor: pointer;
  font-size: 16px;
  margin: 0;
  padding: 8px 15px;
  border-bottom: 1px solid #f5f5f5;
}
.autocomplete-list-name li:last-child {
  border-bottom: 0;
}
.autocomplete-list-name li:hover,
.autocomplete-list-name li.active {
  color: #3c763d;
  background-color: #dff0d8;
}

.require {
  color: #d81b60;
  background-color: #f3bacf;
  border: 1px solid #df487f !important;
}

.require::placeholder {
  color: #d81b60;
}

.bg-lock {
  background-color: #edeef1 !important;
}

.cf-credit:focus {
  outline: none;
}

.cf-credit {
  margin-bottom: 0.5cm;
  font-size: 34px;
  border: 1px #ccc solid;
  border-radius: 10px;
  text-align: center;
  width: 50%;
}

.div-address {
  padding: 10px;
  margin-top: 5px;
}

.hide-content {
  display: none;
}

.edit-mode,
.edit-mode:focus {
  background-color: #ffd070;
  border: #000 solid 1px;
  cursor: pointer;
}

.un-tax {
  text-decoration: line-through;
}

input[type="checkbox"][disabled] {
  color: green;
}

.span-lg-width {
  width: 108px;
}

@media (max-width: 1024px) {
  .span-lg-width {
    width: 45px;
  }

  .span-lg {
    display: none;
  }
}

.input-tax-data {
  height: 56px;
  font-size: 20px;
}

.input-otp {
  border: solid 1px #aaa;
  border-radius: 5px;
}

.form-control-otp {
  -webkit-transition: none;
  transition: none;
  width: 32px;
  height: 32px;
  text-align: center;
}

.form-control-otp:focus {
  color: #3f4254;
  background-color: #ffffff;
  border-color: #884377;
  outline: 0;
}

.form-control-otp.form-control-solid-otp {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #3f4254;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-control-otp.form-control-solid-otp:active,
.form-control-otp.form-control-solid-otp.active,
.form-control-otp.form-control-solid-otp:focus,
.form-control-otp.form-control-solid-otp.focus {
  background-color: #ebedf3;
  border-color: #ebedf3;
  color: #3f4254;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease;
}

.vertifyFail {
  color: #d81b60 !important;
  background-color: #f3bacf !important;
  border: 1px solid #df487f !important;
}

.select2-container {
  width: 100% !important;
}
.select2-container .select2-selection--single {
  height: 40px;
  padding: 0.35em 0;
}

.select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  margin-top: 0.2em;
}

.mx-input {
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
}
.label {
  padding: 3px 10px;
  line-height: 13px;
  color: #fff;
  font-weight: 400;
  border-radius: 2px;
  font-size: 75%;
}
.label-info {
  background-color: #2962ff;
}

.text-notax {
  text-decoration: line-through;
  color: red;
}

.vue-suggestion {
  display: inline-block;
}

.vue-suggestion .vs__list {
  width: 100%;
  z-index: 99999;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  position: relative;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.vue-suggestion .vs__list .vs__list-item {
  background-color: #fff;
  padding: 10px;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
  cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
</style>
